import Drawer from "@material-ui/core/Drawer";
import React, {Fragment} from "react";
import clsx from 'clsx';
import {makeStyles} from "@material-ui/core";
import {drawerWidth} from "../_constants";
import {SectionsList} from "./SectionsList";

const useStyles = makeStyles(theme => ({
    topSpacer: {
        ...theme.mixins.toolbar,
    },
    toolbarIcon: {
        zIndex: theme.zIndex.drawer + 1,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        width: '0'
    },
    toggleSideBarButton: {
        position: 'absolute',
        left: '-24px'
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        }
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    }
}));

interface SidebarProps {
    drawerIsOpen: boolean,
    closeDrawerClicked: () => void
}

export const SideBar: React.FC<SidebarProps> = (props) => {
    const classes = useStyles();
    const {drawerIsOpen, closeDrawerClicked} = props;
    const drawer = drawerIsOpen ? (
        <Drawer key='drawer'
                variant='permanent'
                classes={{paper: clsx(classes.drawerPaper, !drawerIsOpen && classes.drawerPaperClose)}}
                open={drawerIsOpen}>
            <div className={classes.topSpacer}></div>
            <SectionsList closeDrawerClicked={closeDrawerClicked}/>
        </Drawer>
    ) : null;

    return <Fragment>
        {drawer}
    </Fragment>;
};


